(() => {
  if (customElements.get('aos-timeline')) {
    return;
  }

  class AosTimeline extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      AOS.init();
    }

  }

  customElements.define('aos-timeline', AosTimeline);
})();
